import { DistributorParams } from "./shared-dto";

export class RenaultKpiGlobalFilter {
    DistributorFilters: DistributorParams = new DistributorParams();    
    Year: number = new Date().getFullYear();
    Month: number = 0;
    Brand: string[] = [];
    Payment: string = '0';
    Activity: string = '0';
  }